import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects'; // fork 권장
// 'invocie' 오타 주의: 'purchase'로 수정하는 것이 좋습니다.
import purchaseMaintenance, { purchaseMaintenanceSaga } from './purchaseMaintenance'; 

const purchaseMaintenanceModule = combineReducers({
  purchaseMaintenance, 
});

export function* purchaseMaintenanceModuleSaga() {
  yield all([
    fork(purchaseMaintenanceSaga)
  ]);
}

export default purchaseMaintenanceModule;
